import { CurrencyOptions, DEFAULT_CURRENCY_OPTIONS } from 'src/constants/homeSearch'

const K = 1000
const M = 1000000

export const sanitizeCurrency = (amount: string): number => {
  return parseFloat(amount.replace(/[^0-9.]/g, '')) || 0
}

export const formatCurrencyWithOpts = (amount = 0, options: CurrencyOptions = DEFAULT_CURRENCY_OPTIONS): string => {
  const {
    grouping: useGrouping = true,
    minorDigits = true,
    symbol = true,
    sign = false,
    short = false,
    cutoff = 10
  } = options
  let amt = amount
  if (typeof amount === 'string') amt = sanitizeCurrency(amount)
  else if (isNaN(amount)) amt = 0

  let fractionDigits = minorDigits ? 2 : 0
  const symbolOptions = symbol ? { style: 'currency', currency: 'USD' } : { style: 'decimal' }
  const signStr = sign ? (Math.sign(amt) >= 0 ? '+' : '-') : ''

  amt = Math.abs(amt)
  let suffix = ''

  switch (short) {
    case 'K':
      amt = amt / K
      if ((amt % 1).toFixed(2) === '0.00' || amt >= cutoff) fractionDigits = 0
      suffix = 'K'
      break
    case 'M':
      amt = amt / M
      if ((amt % 1).toFixed(2) === '0.00' || amt >= cutoff) fractionDigits = 0
      suffix = 'M'
      break
    case 'auto':
    case true:
      if (amt >= M) {
        amt = amt / M
        if ((amt % 1).toFixed(2) === '0.00' || amt >= cutoff) fractionDigits = 0
        suffix = 'M'
      } else if (amt >= K) {
        amt = amt / K
        if ((amt % 1).toFixed(2) === '0.00' || amt >= cutoff) fractionDigits = 0
        suffix = 'K'
      }
      break
  }

  return `${signStr}${amt.toLocaleString('en-US', {
    ...symbolOptions,
    useGrouping,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  })}${suffix}`
}
